import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
 import {Accordion, AccordionItem, AccordionItemHeading,AccordionItemButton,AccordionItemPanel,} from 'react-accessible-accordion';
class Faqs extends Component {
    state = {  }
    render() { 
        const mystyle = {
            height:'100vh',
            backgroundColor:'#d3d3d3'
        }
        const button = {
            width: '100%',
  margin: '2px',
  padding: '20px',
  border: '1px solid #fff',
  borderRadius: '4px',
  zIndex: 1,
  textAlign: 'left',
  outline: 'none',
  backgroundColor: '#fff',
  fontSize: '1.3em',
  fontWeight: 'bold',
  transition: '100s',

}
const panel = {
    margin: '0px',
    padding: '20px',
    fontSize: '1.2em',
    fontStyle: 'italic',
    backgroundColor: '#fff',
}
        return ( 
            <div style={mystyle}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 px-0">
                      
                        <Accordion  allowZeroExpanded={true}>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    How do I add metrics?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    Click METRICS button on the dashboard then enter your child current height (cm) and weight (kg).
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    Where can I find more Information about SmartGrowthDiary?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    You can visit our office to get more Information about SmartGrowthDary application.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    How can I track growing progress of my child?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    On child dashboard click GROWTH CHART to see progress of your child. You can switch between  height against age chart and weight against age chart.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    Where can I find previous feeding advice?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    On child dashboard click FEEDING ADVICE button to view all previous advice.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    Where can I see my basics Information?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    To view the basic Information after login to the application go to the left of application by clicking on the side bar button.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    How can I change password?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    Click the top-left bar, then at the bottom of the list you will find the option of changing password.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    How can i know if my child is growing well?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    You must fill your child's current weight and height, then you will receive a message to show if your child is growing well or need help.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    How to know if the rate i breastfeed my child per day is correct?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    You must fill your child's current weight and height, then you will receive a message to show if your child is growing well or need help, if your child need help you must enter number of breastfeed per day. Then you will receive message which shows the rate your child has breastfeed and the rate required per day.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    How to know if I feed my child at the required rate per day?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    You must fill your child's current weight and height, then you will receive a message to show if your child is growing well or need help, if your child need help you must enter complementary feed which is type of food, amount and consistency. Then you will receive message which shows the rate your child has fed and the rate required per day.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    How can I add amount of food I fed my child?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    After selecting the type of the food that the child has been fed, you will be able to add amount and consistency of food by clicking the food list.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
        </Accordion>
                        </div>
                    </div>
                </div>
            </div>
         );
    }
}
 
export default Faqs;